export default "__VITE_ASSET__$KUryI6H__"